import styles from "./SuggestedAddress.module.css";

import { Button, Dialog } from "@justworkshr/milo-components";
import { RadioButton, RadioButtonGroup } from "@justworkshr/milo-form";
import { ChangeEvent, useState } from "react";
import { BusinessAddressFormType } from "uicomponents/AddressComponent/FormUtils";

interface SuggestedAddressModelProps {
  suggestedAddress?: BusinessAddressFormType;
  enteredAddress?: BusinessAddressFormType;
  onUseSuggestion: (address: BusinessAddressFormType) => void;
  onKeepCurrent: (address: BusinessAddressFormType) => void;
}

const SuggestedAddressModel = ({
  suggestedAddress,
  enteredAddress,
  onUseSuggestion,
  onKeepCurrent,
}: SuggestedAddressModelProps) => {
  const [selectedOption, setSelectedOption] = useState("useSuggested");

  if (!suggestedAddress || !enteredAddress) {
    return null;
  }

  const enteredAddressStr = `${enteredAddress.address1}${
    enteredAddress.address2 ? `, ${enteredAddress.address2}` : ""
  }
    ${enteredAddress.city}, ${enteredAddress.state} ${enteredAddress.zip}
  `;

  const suggestedAddressStr = `${suggestedAddress.address1}${
    suggestedAddress.address2 ? `, ${suggestedAddress.address2}` : ""
  }
    ${suggestedAddress.city}, ${suggestedAddress.state} ${suggestedAddress.zip}
  `;

  const keepCurrentSelected = selectedOption === "keepCurrent";
  const useSuggestedSelected = selectedOption === "useSuggested";

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  const handleClick = () => {
    if (keepCurrentSelected) {
      onKeepCurrent(enteredAddress);
    } else if (useSuggestedSelected) {
      onUseSuggestion(suggestedAddress);
    }
  };

  const primaryButton = (
    <Button size="sm" onClick={handleClick}>
      Use this address
    </Button>
  );

  return (
    <Dialog
      title="We found a suggestion for your address"
      primaryButton={primaryButton}
      showCloseButton={false}
      size="xl"
      isOpen
    >
      <div className={styles.addressOptions}>
        <RadioButtonGroup
          name="address-options"
          value={selectedOption}
          orientation="horizontal"
          variant="framed"
          onChange={handleChange}
        >
          <RadioButton
            value="keepCurrent"
            checked={keepCurrentSelected}
            label="Current"
            description={enteredAddressStr}
          />
          <RadioButton
            value="useSuggested"
            checked={useSuggestedSelected}
            label="Suggested"
            description={suggestedAddressStr}
          />
        </RadioButtonGroup>
      </div>
    </Dialog>
  );
};

export default SuggestedAddressModel;
